import { useContext } from 'react';
import { LanguageContext } from '../App';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { LANGUAGE_OPTIONS } from '../utils/i18n';

const LanguageSwitcher = () => {
  const { language, switchLanguage } = useContext(LanguageContext);

  const currentLang = LANGUAGE_OPTIONS.find((item) => item.code === language) || LANGUAGE_OPTIONS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="text-white/70 hover:bg-white/5 hover:text-green-400 flex items-center gap-1 p-1.5 md:p-2"
          data-testid="language-switcher"
        >
          <span className="text-base leading-none">{currentLang.flag}</span>
          <span className="text-[10px] sm:text-xs font-semibold">{language.toUpperCase()}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44 bg-gray-900 border-white/10">
        {LANGUAGE_OPTIONS.map((item) => (
          <DropdownMenuItem
            key={item.code}
            onClick={() => switchLanguage(item.code)}
            className={`cursor-pointer text-gray-300 hover:text-green-400 ${language === item.code ? 'bg-white/5' : ''}`}
            data-testid={`lang-${item.code}`}
          >
            <span className="text-xl mr-2">{item.flag}</span>
            {item.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
